import { POSTPriceRuleBody, PUTPriceRuleBody, PUTPriceRulesSettingsBody } from './index'

export const getPriceRules = () => ({
  method: 'GET',
  url: '/modules/price-rules',
  params: {
    Fields: '*',
    PerPage: 999,
    OrderBy: 'PriceRule.CreatedAt|DESC'
  }
})

export const updatePriceRule = (UUID: string, data: PUTPriceRuleBody) => ({
  method: 'PUT',
  url: `/modules/price-rules/${UUID}`,
  data
})

export const createPriceRule = (data: POSTPriceRuleBody) => ({
  method: 'POST',
  url: '/modules/price-rules',
  data
})

export const deletePriceRule = (UUID: string) => ({
  method: 'DELETE',
  url: `/modules/price-rules/${UUID}`
})

export const getPriceRulesSettings = () => ({
  method: 'GET',
  url: '/modules/price-rules/settings'
})

export const updatePriceRulesSettings = (data: PUTPriceRulesSettingsBody) => ({
  method: 'PUT',
  url: '/modules/price-rules/settings',
  data
})
